/**
 * Single-pane mobile inbox: list, thread, or details.
 */
export class MobileInboxPaneController {
  constructor() {
    this.pane = "list";
  }

  /**
   * @param {string | number | null | undefined} selectedId
   * @returns {"list" | "thread" | "details"}
   */
  onSelectionChange(selectedId) {
    this.pane = selectedId ? "thread" : "list";
    return this.pane;
  }

  back() {
    this.pane = this.pane === "details" ? "thread" : "list";
    return this.pane;
  }

  showDetails() {
    this.pane = "details";
    return this.pane;
  }
}
